import React, { useState, useEffect, useContext } from "react";
import { TranslatorContext } from "../../../context/Translator";
import axios from "axios";
import { AnchorComponent, ButtonComponent } from "../../../components/elements";
import { Modal, Row, Col, Form, Table } from "react-bootstrap";
import PageLayout from "../../../layouts/PageLayout";
import { Link } from "react-router-dom";
import Swal from 'sweetalert2';
import '../App/modalstyle.css';

export default function SpecializationIndex() {
    const { t } = useContext(TranslatorContext);

    const AuthToken = localStorage.getItem("authToken")

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [alertModal, setAlertModal] = useState(false);
    const [currentId, setCurrentId] = useState(null);

    // Store Modal States
    const [storeModal, setStoreModal] = useState(false);
    const [storeForm, setStoreForm] = useState({
        name: '',
    });
    const [storeErrors, setStoreErrors] = useState({});
    const [storeLoading, setStoreLoading] = useState(false);

    // Update Modal States
    const [updateModal, setUpdateModal] = useState(false);
    const [updateForm, setUpdateForm] = useState({
        id: null,
        name: ''
    });
    const [updateErrors, setUpdateErrors] = useState({});
    const [updateLoading, setUpdateLoading] = useState(false);

    useEffect(() => {
        fetchSpecializations();
    }, []);

    const fetchSpecializations = () => {
        setLoading(true);

        const token = localStorage.getItem("authToken");

        axios.get(`${process.env.REACT_APP_API_URL}/specializations`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
            .then(res => setData(res.data.specializations))
            .catch(err => console.error(err))
            .finally(() => setLoading(false));
    };

    // Store Modal Functions
    const openStoreModal = () => {
        setStoreForm({ name: '' });
        setStoreErrors({});
        setStoreModal(true);
    };

    const handleStoreChange = (e) => {
        const { name, value } = e.target;
        setStoreForm(prev => ({ ...prev, [name]: value }));
        if (storeErrors[name]) {
            setStoreErrors(prev => ({ ...prev, [name]: '' }));
        }
    };

    const handleStoreSubmit = async (e) => {
        e.preventDefault();
        setStoreLoading(true);
        setStoreErrors({});

        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}/specializations`,
                storeForm,
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("authToken")}`
                    }
                }
            );

            if (response.data.status) {
                fetchSpecializations();
                setStoreModal(false);
                setStoreForm({ name: '' });

                // Success toast
                Swal.fire({
                    toast: true,
                    position: 'top-end',
                    icon: 'success',
                    title: 'Specialization added successfully!',
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true
                });
            }
        } catch (error) {
            if (error.response?.status === 422) {
                setStoreErrors(error.response.data.errors || {});

                // Validation error toast
                Swal.fire({
                    toast: true,
                    position: 'top-end',
                    icon: 'error',
                    title: 'Validation error!',
                    text: 'Please check the form fields.',
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true
                });
            } else {
                console.error('Error creating specialization:', error);

                // General error toast
                Swal.fire({
                    toast: true,
                    position: 'top-end',
                    icon: 'error',
                    title: 'Error!',
                    text: 'Failed to add specialization. Please try again.',
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true
                });
            }
        } finally {
            setStoreLoading(false);
        }
    };

    // Update Modal Functions
    const openUpdateModal = (item) => {
        setUpdateForm({
            id: item.id,
            name: item.name
        });
        setUpdateErrors({});
        setUpdateModal(true);
    };

    const handleUpdateChange = (e) => {
        const { name, value } = e.target;
        setUpdateForm(prev => ({ ...prev, [name]: value }));
        if (updateErrors[name]) {
            setUpdateErrors(prev => ({ ...prev, [name]: '' }));
        }
    };

    const handleUpdateSubmit = async (e) => {
        e.preventDefault();
        setUpdateLoading(true);
        setUpdateErrors({});

        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}/specializations-update/${updateForm.id}`,
                {
                    name: updateForm.name
                },
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("authToken")}`
                    }
                }
            );

            if (response.data.status) {
                fetchSpecializations();
                setUpdateModal(false);

                // Success toast
                Swal.fire({
                    toast: true,
                    position: 'top-end',
                    icon: 'success',
                    title: 'Specialization updated successfully!',
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true
                });
            }
        } catch (error) {
            if (error.response?.status === 422) {
                setUpdateErrors(error.response.data.errors || {});

                // Validation error toast
                Swal.fire({
                    toast: true,
                    position: 'top-end',
                    icon: 'error',
                    title: 'Validation error!',
                    text: 'Please check the form fields.',
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true
                });
            } else {
                console.error('Error updating specialization:', error);

                // General error toast
                Swal.fire({
                    toast: true,
                    position: 'top-end',
                    icon: 'error',
                    title: 'Error!',
                    text: 'Failed to update specialization. Please try again.',
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true
                });
            }
        } finally {
            setUpdateLoading(false);
        }
    };

    const handleDelete = async (id) => {
        // Show confirmation dialog
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'Cancel'
        });

        if (result.isConfirmed) {
            try {
                // Show loading state
                Swal.fire({
                    title: 'Deleting...',
                    text: 'Please wait',
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading();
                    }
                });

                // Make delete API call
                const response = await axios.delete(
                    `${process.env.REACT_APP_API_URL}/specializations/${id}`,
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem("authToken")}`
                        }
                    }
                );

                if (response.data.status) {
                    fetchSpecializations();

                    // Close the loading alert
                    Swal.close();

                    // Success toast
                    Swal.fire({
                        toast: true,
                        position: 'top-end',
                        icon: 'success',
                        title: 'Specialization deleted successfully!',
                        showConfirmButton: false,
                        timer: 3000,
                        timerProgressBar: true
                    });
                }
            } catch (error) {
                Swal.close();

                // Error toast
                Swal.fire({
                    toast: true,
                    position: 'top-end',
                    icon: 'error',
                    title: 'Error!',
                    text: error.response?.data?.message || 'Failed to delete specialization. Please try again.',
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true
                });
            }
        }

        setAlertModal(false);
    };

    if (loading) return <PageLayout><p>{t("loading")}...</p></PageLayout>;

    return (
        <PageLayout>
            <Row>
                <Col xl={12}>
                    <div className="mc-card">
                        <div className="mc-breadcrumb">
                            <h3 className="mc-breadcrumb-title">{t('specializations')}</h3>
                            <ul className="mc-breadcrumb-list">
                                <li className="mc-breadcrumb-item">
                                    <Link to="#" className="mc-breadcrumb-link">{t('home')}</Link>
                                </li>
                                <li className="mc-breadcrumb-item">
                                    <Link to="#" className="mc-breadcrumb-link">{t('specializations')}</Link>
                                </li>
                                <li className="mc-breadcrumb-item">{t('list')}</li>
                            </ul>
                        </div>
                    </div>
                </Col>

                <Col xl={12}>
                    <div className="mc-card">
                        {/* Add New Button */}
                        <div className="mc-card-header d-flex justify-content-between align-items-center p-3">
                            <h5 className="mc-card-title mb-0">{t('specializations list')}</h5>
                            <ButtonComponent
                                type="button"
                                className="btn btn-primary d-flex align-items-center"
                                onClick={openStoreModal}
                            >
                                <i className="material-icons">add</i>
                                {t('add Specialization')}
                            </ButtonComponent>
                        </div>

                        <Row>
                            <Col xl={12}>
                                <div className="mc-card">
                                    <div className="table-responsive-wrapper">
                                        <Table responsive className="table mb-0">
                                            <thead>
                                                <tr>
                                                    <th>
                                                        <div className="mc-table-check">
                                                            <p>#</p>
                                                        </div>
                                                    </th>
                                                    <th>{t('name')}</th>
                                                    <th>{t('actions')}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {data.map((item, index) => (
                                                    <tr key={item.id}>
                                                        <td>
                                                            <div className="mc-table-check">
                                                                <p>{index + 1}</p>
                                                            </div>
                                                        </td>
                                                        <td>{item.name}</td>
                                                        <td>
                                                            <div className="mc-table-action">
                                                                <ButtonComponent
                                                                    type="button"
                                                                    className="material-icons edit"
                                                                    onClick={() => openUpdateModal(item)}
                                                                    title="Edit"
                                                                >
                                                                    edit
                                                                </ButtonComponent>
                                                                <ButtonComponent
                                                                    type="button"
                                                                    className="material-icons delete"
                                                                    onClick={() => {
                                                                        setCurrentId(item.id);
                                                                        handleDelete(item.id);
                                                                    }}
                                                                >
                                                                    delete
                                                                </ButtonComponent>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>

                                        {/* Delete Confirmation Modal - Keep for compatibility but SweetAlert handles it */}
                                        <Modal show={alertModal} onHide={() => setAlertModal(false)}>
                                            <div className="mc-alert-modal p-4 text-center p-3">
                                                <i className="material-icons" style={{ fontSize: '50px', color: 'red' }}>new_releases</i>
                                                <h3 className="mt-3">{t("Are you sure?")}</h3>
                                                <p>{t("Want to delete this specialization?")}</p>
                                                <div className="d-flex justify-content-center gap-2 mt-3">
                                                    <ButtonComponent
                                                        type="button"
                                                        className="btn btn-secondary"
                                                        onClick={() => setAlertModal(false)}
                                                    >
                                                        {t('close')}
                                                    </ButtonComponent>
                                                    {/* <ButtonComponent
                                                    type="button"
                                                    className="btn btn-danger"
                                                    onClick={() => handleDelete(currentId)}
                                                >
                                                    {t('delete')}
                                                </ButtonComponent> */}
                                                </div>
                                            </div>
                                        </Modal>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Col>
            </Row>

            {/* Store Modal */}
            <Modal show={storeModal} onHide={() => setStoreModal(false)} centered dialogClassName="custom-modal-dialog"
                contentClassName="custom-modal-content">
                <Modal.Header closeButton className="p-3">
                    <Modal.Title>{t('add specialization')}</Modal.Title>
                </Modal.Header>
                <Form onSubmit={handleStoreSubmit}>
                    <Modal.Body>
                        <Form.Group className="mb-3">
                            <Form.Label>{t('name')} <span className="text-danger">*</span></Form.Label>
                            <Form.Control
                                type="text"
                                name="name"
                                value={storeForm.name}
                                onChange={handleStoreChange}
                                isInvalid={!!storeErrors.name}
                            />
                            <Form.Control.Feedback type="invalid">
                                {storeErrors.name?.[0]}
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Modal.Body>
                    <Modal.Footer className="p-3">
                        <ButtonComponent
                            type="button"
                            className="btn btn-secondary"
                            onClick={() => setStoreModal(false)}
                        >
                            {t('cancel')}
                        </ButtonComponent>
                        <ButtonComponent
                            type="submit"
                            className="btn btn-primary"
                            disabled={storeLoading}
                        >
                            {storeLoading ? (
                                <span className="spinner-border spinner-border-sm me-2"></span>
                            ) : null}
                            {t('save')}
                        </ButtonComponent>
                    </Modal.Footer>
                </Form>
            </Modal>

            {/* Update Modal */}
            <Modal show={updateModal} onHide={() => setUpdateModal(false)} centered dialogClassName="custom-modal-dialog"
                contentClassName="custom-modal-content">
                <Modal.Header closeButton className="p-3">
                    <Modal.Title>{t('edit specialization')}</Modal.Title>
                </Modal.Header>
                <Form onSubmit={handleUpdateSubmit}>
                    <Modal.Body>
                        <Form.Group className="mb-3">
                            <Form.Label>{t('name')} <span className="text-danger">*</span></Form.Label>
                            <Form.Control
                                type="text"
                                name="name"
                                value={updateForm.name}
                                onChange={handleUpdateChange}
                                isInvalid={!!updateErrors.name}
                            />
                            <Form.Control.Feedback type="invalid">
                                {updateErrors.name?.[0]}
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Modal.Body>
                    <Modal.Footer className="p-3">
                        <ButtonComponent
                            type="button"
                            className="btn btn-secondary"
                            onClick={() => setUpdateModal(false)}
                        >
                            {t('cancel')}
                        </ButtonComponent>
                        <ButtonComponent
                            type="submit"
                            className="btn btn-primary"
                            disabled={updateLoading}
                        >
                            {updateLoading ? (
                                <span className="spinner-border spinner-border-sm me-2"></span>
                            ) : null}
                            {t('update')}
                        </ButtonComponent>
                    </Modal.Footer>
                </Form>
            </Modal>
        </PageLayout>
    );
}